import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 运价详情-船期信息
export function queryShippingSchedule(data) {
  return request({
    url: URL.price.shippingSchedule.queryShippingSchedule,
    method: 'post',
    data
  })
}

// 运价详情-批量查询船期信息
export function getShippingSchedules(data) {
  return request({
    url: URL.price.shippingSchedule.getShippingSchedules,
    method: 'post',
    data
  })
}
// 整箱船期管理-保存
export function saveShippingSchedule(data) {
  return request({
    url: URL.price.shippingSchedule.saveShippingSchedule,
    method: 'post',
    data
  })
}
// 整箱船期管理-删除
export function deleteShippingSchedule(data) {
  return request({
    url: URL.price.shippingSchedule.deleteShippingSchedule,
    method: 'post',
    data
  })
}
